import styled from "styled-components";

export const ChainsTab = styled.div`
  display: flex;
  border-radius: 26px;
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  padding: 2px;
  width: fit-content;
  overflow: hidden;
  margin: 24px 24px 0;
  @media (min-width: 1024px) {
    margin-top: 32px;
    margin: 32px 0 0;
  }
`;

export const ChainsTabItem = styled.button`
  cursor: pointer;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 24px 16px 16px;
  border: 0;
  outline: 0;
  border-radius: var(--rounding-radius-xl, 24px);
  color: var(--text-primary);
  text-align: left;
  white-space: nowrap;

  &.active {
    box-shadow: 0px 4px 8px 0px rgba(51, 20, 0, 0.04),
      0px 8px 24px 0px rgba(51, 20, 0, 0.08);
    background: var(--fill-elevated);
  }
`;

export const OverflowContainer = styled.div`
  overflow: scroll;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }

  &::-moz-scrollbar {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar:horizontal {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    opacity: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    width: 0 !important;
    height: 0 !important;
    opacity: 0;
    background: rgba(255, 255, 255, 0);
    background-color: transparent;
    display: none !important;
  }
  &::-webkit-scrollbar-track-piece {
    width: 0 !important;
    height: 0 !important;
    opacity: 0;
    background: rgba(255, 255, 255, 0);
    background-color: transparent;
    display: none !important;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
    opacity: 0;
  }

  &::-webkit-scrollbar-track {
    opacity: 0;
    background: transparent;
    background-color: transparent;
    width: 0 !important;
    height: 0 !important;
    display: none !important;
  }
  @media (max-width: 1024px) {
    margin: 0 -24px;
    width: calc(100% + 48px);
  }
`;
